import React from 'react';
import { sumBy } from 'lodash';
import cx from 'classnames';
import moment from 'moment';
import { LOSING_MESSAGE, PRIZE_CODE } from './constants';
import { v4 as uuidv4 } from 'uuid';

export const capitalizeFirstLetter = (str) => {
  return str.charAt(0).toUpperCase() + str.slice(1);
};

export const renderStatus = (status, label) => {
  const className = status
    ? `badge-${`${status}`.replace(/\s+/g, '-').toLowerCase()}`
    : '';
  return (
    <span className={cx('badge', 'badge-primary', className)}>{label}</span>
  );
};

export const renderDate = (date, format) =>
  date ? format ? moment(date, format).format('DD/MM/YYYY') : moment(date).format('DD/MM/YYYY') : '';

export const renderDateTime = (date) =>
  date ? (
    <div>
      {moment(date).format('DD-MM-YYYY')}
      <br />
      {moment(date).format('HH:mm:ss')}
    </div>
  ) : (
      ''
    );


export const renderMoney = (price) => {
  // return Number(price).toLocaleString("vi-VN");
  return !!Number(price) ? Number(price).toLocaleString('vi-VN') : price;
};

export const renderTotal = (orderItems) => {
  return sumBy(
    orderItems,
    (orderItem) => (orderItem.price - orderItem.discount) * orderItem.quantity
  ).toLocaleString('vi-VN');
};

export const renderNumberFixed = (number, fixed = 2) =>
  number && !isNaN(number) ? Number(number).toFixed(fixed) : 0;

export const getIOSNotch = (height) => {
  return [812, 896, 844, 926].indexOf(height) >= 0 ? 44 : 20;
};

export const numberFormat = (number, separator = ".") =>
  number && !isNaN(number) ? Number(number).toLocaleString("en-US").replace(/,/g, separator) : 0;

export const renderRandMessage = () => {
  return LOSING_MESSAGE[getRandom(LOSING_MESSAGE.length)];

}

export const getDeviceId = () => {
  let deviceIdCommon = localStorage.getItem('MB_DEVICE_ID');
  if (!deviceIdCommon) {
    deviceIdCommon = uuidv4();
    localStorage.setItem("MB_DEVICE_ID", deviceIdCommon + "");
  }
  return deviceIdCommon;
}

export const getRefNo = (userId) => {
  var now = new Date();
  var refNo = "";
  refNo =
    refNo +
    userId +
    "-" +
    now.getFullYear() +
    "" +
    now.getMonth() +
    "" +
    now.getDate() +
    "" +
    now.getHours() +
    "" +
    now.getMinutes() +
    "" +
    now.getSeconds() +
    "" +
    now.getMilliseconds() +
    getRandom(1000)
    // Math.floor(Math.random() * 1000)
    ;

  return refNo;
}

export const getRandom = max => Math.floor(Math.random() * max);

export const getRandomFromTo = (from, to) => Math.floor(from + Math.random() * (to - from));

export const isAfter = (firstDate, secondDate, format = "MM/YYYY") => {
  return moment(firstDate, format).isAfter(moment(secondDate, format));
}

export const compareMonth = (month1, month2) => {
  return isAfter(month1, month2) ? 0 : -1;
}
export const getRandomArrayFromTo = (min, max, length) => {
  let arr = [];
  for (let index = 0; index < length; index++) {
    arr[index] = getRandomFromTo(min, max)
  }
  return arr;
}